// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    PARTNUMBERS_CREATE_REQUEST,
    PARTNUMBERS_UPDATE_REQUEST,
    PARTNUMBERS_GET_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    partNumberCreateResult,
    partNumberGetResult,
    partNumberUpdateResult,
} from 'Redux/actions';

// Helpers
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* createPartNumber({ payload }) {
    try {

        let QUERY = `
            mutation createPartNumber ($partNumber: String!, $deviceModelId: Int!, $network: String) {
                result: createPartNumber (partNumber: $partNumber, deviceModelId: $deviceModelId, network: $network) {
                    id
                    partNumber
                    deviceModelId
                    deviceModel {
                        id
                        unitTypeId
                        name
                        manufacturerId
                    }
                    network
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(partNumberCreateResult(data?.result))

    } catch (exc) {
        yield put(partNumberCreateResult())
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/partNumbersTab/.components/createEditPartNumber/redux/saga",
            "createPartNumber"
        )
    }
}

function* updatePartNumber({ payload }) {
    try {

        let QUERY = `
            mutation updatePartNumber ($id: Int!, $partNumber: String, $deviceModelId: Int, $network: String) {
                result: updatePartNumber (id: $id, partNumber: $partNumber, deviceModelId: $deviceModelId, network: $network) {
                    id
                    partNumber
                    deviceModelId
                    deviceModel {
                        id
                        unitTypeId
                        name
                    }
                    network
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(partNumberUpdateResult(data?.result))

    } catch (exc) {
        yield put(partNumberUpdateResult())
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/partNumbersTab/.components/createEditPartNumber/redux/saga",
            "updatePartNumber"
        )
    }
}

function* getPartNumber({ payload }) {
    try {
        let QUERY = `
            query getPartNumber ($id: Int!) {
                result: getPartNumber (id: $id) {
                    id
                    partNumber
                    deviceModelId
                    deviceModel {
                        id
                        unitTypeId
                        unitType {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                    network
                }
            }
        `;


        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

       yield put(partNumberGetResult(data?.result));

    } catch (exc) {
        yield put(partNumberGetResult());
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/partNumbersTab/.components/createEditPartNumber/redux/saga",
            "getPartNumber"
        )
    }
}

function* watchMethods() {
    yield takeEvery(PARTNUMBERS_CREATE_REQUEST, createPartNumber);
    yield takeEvery(PARTNUMBERS_UPDATE_REQUEST, updatePartNumber);
    yield takeEvery(PARTNUMBERS_GET_REQUEST, getPartNumber);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}